import React, {useState, useEffect} from 'react';
import { useStoreState } from 'easy-peasy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import marketing from '../../../services/marketing';
import { tcGenerator } from '../../../services/tcGenerator';
import ErrorModal from '../../body/forms/components/ErrorModal'
import LoadingModal from '../../body/forms/components/LoadingModal';
import { FLOW, PRODUCT } from '../../../models/websiteTypesConstants';


function Features() {

    const mainSettings = useStoreState(state => state.siteSettingsModel.mainSettings);
    const routingSettings = useStoreState(state => state.routingSettingsModel.routingSettings);
    const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);
    const productSettings = useStoreState(state => state.siteSettingsModel.productSettings);
    const utm = new marketing();
    const [errorShow, setErrorShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const closeError = () => setErrorShow(false);
    const [loading, setLoading] = useState(false);
    const pCode = useState(mainSettings.ProductCode);

    const bulletStyle = {
        color: brandSettings.ProductName === PRODUCT.Grand.bank ? "black" : (mainSettings.Flow === FLOW.PREQUAL ? brandSettings.Secondary : brandSettings.Primary)
    };

    const btnViewTermsStyle = {
        backgroundColor: (brandSettings.ProductName === PRODUCT.Grand.bank ? "black" : brandSettings.Primary),
        marginTop: "15px"
    };

    const showCardAndTitle = () => {
        if (mainSettings.Flow === FLOW.PREQUAL) {
            return (<div>
                <div className='col-lg-12' style={{"textAlign" : "center"}}>
                  <img style={{"marginBottom" : "0 !important"}} alt="" src={brandSettings.CardImage} className="col-lg-12 card-img" />
                  {
                      brandSettings.ProductName === PRODUCT.Surge ? 
                      <p style={{"fontSize" : "small", "color" : "black"}}>A $9.95 fee applies on Premium Designs.</p>
                      :
                      <></>
                  }
                </div>
                <div className="col-lg-12 mt-4" style={(brandSettings.ProductName === PRODUCT.Grand.bank ? {color: brandSettings.Primary} : {})}>
                    <h2><b>The {(brandSettings.ProductName === PRODUCT.Grand.bank ? (<>Grand.bank<sup>&reg;</sup> Plus</>) : brandSettings.ProductName)} Mastercard<sup>&reg;</sup> Features{brandSettings.ProductName === PRODUCT.Grand.bank ? ':':''}</b></h2>
                </div>
            </div>);
        }
        else if (mainSettings.Flow === FLOW.CFC) {
            return null;
        }
    }

    const handleViewTerms = async (e) => {
        if (e) e.preventDefault();
    
        const ProductCode = localStorage.getItem("TCProductCode");
        setLoading(true);
        try {
            const { fileContent, hasErrors, errorMessage } = await tcGenerator(ProductCode);
            setLoading(false);
            if (fileContent !== null && !hasErrors) {
              const pdfContent = `data:application/pdf;base64,${fileContent}`;
              const newWindow = window.open('', '_blank');
              newWindow && newWindow.document.write(`<iframe width='100%' height='100%' src='${pdfContent}'></iframe>`);
              return;
            } else {
              setErrorMessage(errorMessage);
              setErrorShow(true);
              return;
            }
        } catch (err) {
            setLoading(false)
            setErrorMessage(`${err.message}`);
            setErrorShow(true);
            return;
        }
    };

    const handleRetry = () => {
        setErrorShow(false);
        handleViewTerms();
      };

    useEffect(() => {
        localStorage.setItem("TCProductCode", pCode)
    },[pCode])

    return (
      <div>
        {showCardAndTitle()}
        {productSettings.Features.map((i, j) => {
          return (
            <div className="feature-item col-lg-12" key={j}>
              <LoadingModal
                show={loading}
                message="Loading Terms & Conditions..."
              />
              <ErrorModal
                size="sm"
                show={errorShow}
                message={errorMessage}
                closeError={closeError}
                onRetry={handleRetry}
              />
              {
                i.Title && (
                  <>
                    <div className="feature-bullet">
                      <span style={bulletStyle}>
                        <FontAwesomeIcon icon={faCircle} />
                      </span>
                    </div>
                    <div className="feature-title">
                      <h4>
                        <b>{i.Title}</b>
                      </h4>
                    </div>
                  </>
                )
              }
              <div className="p feature-desc">
                <span
                  dangerouslySetInnerHTML={{
                    __html: i.Description.replace(
                      "%terms and conditions%",
                      '<a href="' + productSettings.TermsUrl + '" target="_blank">terms and conditions</a>'
                    ),
                  }}
                />
              </div>
            </div>
          );
        })}
        
        {mainSettings.Flow === FLOW.PREQUAL ? (
          <div className="col-lg-12 mt-2" align="center">
            {routingSettings.TermsHeaderCDN ? 
              <a id="btn-view-terms" href={productSettings.TermsUrl} target="_blank" rel="noopener noreferrer" className="btn" style={btnViewTermsStyle}>
                See Full Terms
              </a> 
            :
              <a id="btn-view-terms" onClick={(e) => { handleViewTerms(e); utm.updateSessionReport("termsButton"); }} className="btn" style={btnViewTermsStyle}>
                See Full Terms
              </a>
            }
          </div>
        ) : null}
      </div>
    );
}

export default Features;